import { Action } from '@ngrx/store';

export enum IncidentViewActionTypes {
  UpdateIncidentViewType = '[Incidents] Update Incident View Type',
}

export class UpdateIncidentViewType implements Action {
  public readonly type = IncidentViewActionTypes.UpdateIncidentViewType;

  constructor(
    public payload: {
      isListView: boolean;
    }
  ) {}
}

export type IncidentsViewActions = UpdateIncidentViewType;
